<!--
 * @Description: 账号开户
 * @Date: 2020-11-03 09:41:19
-->
<template>
  <div>
    <h3 class="kaihu">账号开户</h3>
    <step :active="0"></step>
    <p class="notes" style="padding-left:124px;">
      请上传的证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过2M。
    </p>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="210px"
      class="ruleForm"
    >
      <div class="colorBlock">公司信息：</div>
      <el-form-item>
        <span slot="label" class="elLabel">公司名称：</span>
        {{ user.userName }}
      </el-form-item>
      <div class="flexBox">
        <el-form-item label="公司电话：" prop="companyPhone" class="leftLabel">
          <span slot="label" class="elLabel">公司电话：</span>
          <el-input
            v-model="ruleForm.companyPhone"
            placeholder="请输入公司电话"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="企业主体类型："
          prop="companyMainType"
          class="rightLabel"
        >
          <span slot="label" class="elLabel">企业主体类型：</span>
          <el-select
            v-model="ruleForm.companyMainType"
            placeholder="请选择企业主体类型"
          >
            <el-option
              v-for="item in companyType"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="flexBox">
        <div class="leftLabel">
          <el-form-item label="公司证件号码：" prop="companyCardType">
            <span slot="label" class="elLabel">公司证件号码：</span>
            <el-select
              v-model="ruleForm.companyCardType"
              placeholder="请选择证件类型"
            >
              <el-option
                v-for="item in cardType"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-input
              v-model="ruleForm.companyCardNo"
              placeholder="请输入对应证件码"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户证件信息：" prop="openAccountType">
            <span slot="label" class="elLabel">开户证件信息：</span>
            <el-select
              v-model="ruleForm.openAccountType"
              placeholder="请选择证件类型"
            >
              <el-option
                v-for="item in kaihuType"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-input
              v-model="ruleForm.openAccountCode"
              placeholder="请输入对应证件码"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="注册地址："
            prop="companyBusinessAddress"
            class="leftLabel"
          >
            <span slot="label" class="elLabel">注册地址：</span>
            <el-input
              v-model="ruleForm.companyBusinessAddress"
              placeholder="请输入营业执照的注册地址"
            ></el-input>
          </el-form-item>
        </div>
        <div class="rightLabel">
          <el-form-item label="营业执照副本：" prop="companyBusinessLicense">
            <span slot="label" class="elLabel">
              营业执照副本：
              <br />
              <i class="redHint">
                请上传驸有公章
                <br />
                的营业执照副本
              </i>
            </span>
            <UploadImgOne
              :initUrl="ruleForm.companyBusinessLicense"
              @upload-done="coverPicDone"
              :noNeedDefaultImg="true"
              placeWord="营业执照副本"
            ></UploadImgOne>
          </el-form-item>
          <step1Dt
            :value="ruleForm"
            label="营业执照"
            keyName="companyBusiness"
          />
        </div>
      </div>
      <div class="colorBlock">法人信息：</div>
      <div class="flexBox">
        <el-form-item
          label="法人姓名："
          prop="legalPersonName"
          class="leftLabel"
        >
          <span slot="label" class="elLabel">法人姓名：</span>
          <el-input
            v-model="ruleForm.legalPersonName"
            placeholder="请输入法人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="法人身份证号："
          prop="legalPersonCardCode"
          class="rightLabel"
        >
          <span slot="label" class="elLabel">法人身份证号：</span>
          <el-input
            v-model="ruleForm.legalPersonCardCode"
            placeholder="请输入法人身份证号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="flexBox" style="align-items:center">
        <el-form-item
          label="法人身份证正反面："
          style="display:flex;"
          class="flexItem leftLabel"
          prop="legalPersonCardZheng"
        >
          <span slot="label" class="elLabel">
            法人身份证正反面：
            <br />
            <i class="redHint" style="width:126px;">企业用户需加盖公章</i>
          </span>
          <UploadImgOne
            :initUrl="ruleForm.legalPersonCardZheng"
            @upload-done="coverPicDone2"
            placeWord="个人信息页"
            :noNeedDefaultImg="true"
          ></UploadImgOne>
          <UploadImgOne
            :initUrl="ruleForm.legalPersonCardFan"
            @upload-done="coverPicDone3"
            placeWord="国徽页"
            :noNeedDefaultImg="true"
          ></UploadImgOne>
        </el-form-item>
        <step1Dt :value="ruleForm" keyName="legalPersonCard" />
      </div>
      <div
        v-if="selectBankName === 'fyBank'"
        class="flexBox"
        style="align-items:center"
      >
        <el-form-item label="法人手机号：" prop="legalPhone" class="rightLabel">
          <span slot="label" class="elLabel">法人手机号：</span>
          <el-input
            v-model="ruleForm.legalPhone"
            placeholder="请输入法人手机号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="colorBlock">银行信息：</div>
      <div class="flexBox">
        <el-form-item label="开户银行：" prop="openBankName" class="leftLabel">
          <span slot="label" class="elLabel">开户银行：</span>
          <dic-select
            @dic-select-obj="saveProId"
            :fuzzyDef="searchBank"
            :prop="ProProp"
            :ajaxQueryObj="{
              payPassagewayCode: selectBankName
            }"
            ajaxQuery="name"
            :defaultActive="defaultBank"
            placeholder="请选择开户银行"
          ></dic-select>
        </el-form-item>
        <el-form-item label="开户名：" prop="openName" class="rightLabel">
          <span slot="label" class="elLabel">开户名：</span>
          <el-input
            v-model="ruleForm.openName"
            placeholder="请输入开户名"
          ></el-input>
        </el-form-item>
      </div>
      <div class="flexBox">
        <el-form-item
          label="银行账号："
          prop="openBankNumber"
          class="leftLabel"
        >
          <span slot="label" class="elLabel">银行账号：</span>
          <el-input
            v-model="ruleForm.openBankNumber"
            placeholder="请输入银行账号"
          ></el-input>
        </el-form-item>
      </div>

      <div class="colorBlock">经办人信息：</div>
      <div class="flexBox">
        <el-form-item
          label="经办人姓名："
          prop="transactorName"
          class="leftLabel"
        >
          <span slot="label" class="elLabel">经办人姓名：</span>
          <el-input
            v-model="ruleForm.transactorName"
            placeholder="请输入经办人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="transactorCardCode" class="rightLabel">
          <span slot="label" class="elLabel">经办人身份证号：</span>
          <el-input
            v-model="ruleForm.transactorCardCode"
            placeholder="请输入经办人身份证号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="flexBox">
        <div class="leftLabel">
          <el-form-item label="经办人手机号：" prop="transactorPhone">
            <span slot="label" class="elLabel">经办人手机号：</span>
            <el-input
              v-model="ruleForm.transactorPhone"
              placeholder="请输入经办人手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="经办人邮箱：" prop="transactorEmail">
            <span slot="label" class="elLabel">经办人邮箱：</span>
            <el-input
              v-model.trim="ruleForm.transactorEmail"
              placeholder="请输入经办人邮箱"
            ></el-input>
          </el-form-item>
        </div>
        <step1Dt :value="ruleForm" keyName="transactorCard" />
      </div>
      <el-form-item
        label="经办人身份证正反面："
        style="display:flex;"
        class="flexItem"
        prop="transactorCardZheng"
      >
        <span slot="label" class="elLabel">
          经办人身份证正反面：
          <br />
          <i class="redHint" style="width:126px;">企业用户需加盖公章</i>
        </span>
        <UploadImgOne
          :initUrl="ruleForm.transactorCardZheng"
          @upload-done="coverPicDone4"
          placeWord="个人信息页"
          :noNeedDefaultImg="true"
        ></UploadImgOne>
        <UploadImgOne
          :initUrl="ruleForm.transactorCardFan"
          @upload-done="coverPicDone5"
          placeWord="国徽页"
          :noNeedDefaultImg="true"
        ></UploadImgOne>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="checked" style="width:100%;text-align:center;">
          我同意遵守
          <a
            v-if="selectBankName === 'zbBank'"
            href="//cdn.yxvzb.com/WEB/SaaS/agreement/武汉众邦银行E账通系统开户三方协议-企业（V1.0版本）.docx"
          >
            《武汉众邦银行E账通系统开户三方协议》
          </a>
          <a
            v-else-if="selectBankName === 'fyBank'"
            href="//cdn.yxvzb.com/WEB/SaaS/agreement/富友-向日葵平台专用账户协议.docx"
          >
            《富友支付开户三方协议》
          </a>
        </el-checkbox>
      </el-form-item>
      <el-form-item>
        <div style="text-align:center">
          <!-- 只有线下可以返回 -->
          <el-button
            v-if="offlineProject === 2"
            @click="$emit('changeComp', { type: 0, currentCom: 'dashBoard' })"
          >
            返回
          </el-button>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            :loading="btLoading"
            :disabled="!checked"
          >
            提交
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { dictionaries } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
import step from './step.vue';
import UploadImgOne from '@/components/Common/newUpLoadImgOne.vue';
import { getStorage } from '@/tools/storage';
import { btLoading } from '@/Mixin/btLoading';
import step1ZbMixin from '../mixins/setp1-zb-mixin';
import step1Dt from './step1-dt.vue';
export default {
  mixins: [btLoading, step1ZbMixin],
  props: {
    selectBankName: String,
    authStatus: Object
  },
  data() {
    const checkOpenBankCityCode = (rule, value, callback) => {
      if (!this.ruleForm.openBankCityCode) {
        callback(new Error('请选择开户行所在地'));
      } else {
        callback();
      }
    };
    const checkLegalPersonCardZheng = (rule, value, callback) => {
      if (
        !this.ruleForm.legalPersonCardZheng ||
        !this.ruleForm.legalPersonCardFan
      ) {
        callback(new Error('请上传法人身份证'));
      } else {
        callback();
      }
    };
    const checkTransactorCardZheng = (rule, value, callback) => {
      if (
        !this.ruleForm.transactorCardZheng ||
        !this.ruleForm.transactorCardFan
      ) {
        callback(new Error('请上传经办人身份证'));
      } else {
        callback();
      }
    };
    const checkOpenBankName = (rule, value, callback) => {
      if (!this.ruleForm.openBankName) {
        callback(new Error('请选择开户银行'));
      } else {
        callback();
      }
    };
    const checkCompanyBusinessLicense = (rule, value, callback) => {
      if (!this.ruleForm.companyBusinessLicense) {
        callback(new Error('请上传营业执照'));
      } else {
        callback();
      }
    };
    const checkOpenAccountType = (rule, value, callback) => {
      if (!this.ruleForm.openAccountType || !this.ruleForm.openAccountCode) {
        callback(new Error('请选择开户证件类型并填写证件号'));
      } else {
        callback();
      }
    };
    return {
      user: getStorage('user'),
      ruleForm: {
        phone: '',
        type: 1,
        zhizhaoCopy: '',
        openBankProvinceCode: '',
        companyBusinessLicense: '', //todo：图片上传本机无法上传所以写死 记得修改

        legalPersonCardZheng: '',
        legalPersonCardFan: '',

        transactorCardZheng: '',
        transactorCardFan: ''
      },
      checked: false,
      offlineProject: 0,
      companyType: [
        { label: ' 商业公司', key: 1 }
        // { label: '个体工商户', key: 2 }
      ],
      cardType: [
        // { label: '个体工商户', key: 0 },
        // { label: '三证三号', key: 1 },
        { label: '三证合一', key: 2 }
      ],
      kaihuType: [
        { label: '开户许可证核准号', key: 1 },
        { label: '基本存款账户编号', key: 2 }
      ],
      rules: {
        companyPhone: [
          {
            required: true,
            message: '请输入公司电话',
            trigger: 'change'
          }
        ],
        companyMainType: [
          {
            required: true,
            message: '请选择企业主体类型',
            trigger: 'change'
          }
        ],
        companyCardType: [
          {
            required: true,
            message: '请选择公司证件编码类型',
            trigger: 'change'
          }
        ],
        companyCardNo: [
          {
            required: true,
            message: '请输入公司证件编码',
            trigger: 'change'
          }
        ],
        companyBusinessLicense: [
          {
            required: true,
            validator: checkCompanyBusinessLicense,
            trigger: 'change'
          }
        ],
        openAccountType: [
          {
            required: true,
            validator: checkOpenAccountType,
            trigger: 'change'
          }
        ],
        openAccountCode: [
          {
            required: true,
            message: '请输入开户证件编码',
            trigger: 'change'
          }
        ],
        legalPersonName: [
          {
            required: true,
            message: '请输入法人姓名',
            trigger: 'change'
          }
        ],
        legalPersonCardZheng: [
          {
            required: true,
            validator: checkLegalPersonCardZheng,
            trigger: 'change'
          }
        ],
        legalPersonCardCode: [
          {
            required: true,
            message: '请输入法人身份证号',
            trigger: 'change'
          }
        ],
        legalPhone: [
          {
            required: true,
            message: '请输入法人手机号',
            trigger: 'change'
          }
        ],
        legalPersonCardFan: [
          {
            required: true,
            message: '请上传法人身份证反面',
            trigger: 'change'
          }
        ],
        openBankName: [
          {
            required: true,
            validator: checkOpenBankName,
            trigger: 'blur'
          }
        ],
        openName: [
          {
            required: true,
            message: '请输入开户名',
            trigger: 'change'
          }
        ],
        openBankNumber: [
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'change'
          }
        ],
        openBankCityCode: [
          {
            required: true,
            trigger: 'blur',
            validator: checkOpenBankCityCode
          }
        ],
        openBankAddress: [
          {
            required: true,
            message: '请输入银行支行全称', // todojml
            trigger: 'change'
          }
        ],
        transactorCardCode: [
          {
            required: true,
            message: '请输入经办人身份证号',
            trigger: 'change'
          }
        ],
        transactorPhone: [
          {
            required: true,
            message: '请输入经办人手机号',
            trigger: 'change'
          }
        ],
        transactorName: [
          {
            required: true,
            message: '请输入经办人姓名',
            trigger: 'change'
          }
        ],
        transactorEmail: [
          { required: true, message: '请输入经办人邮箱地址', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ],
        transactorCardZheng: [
          {
            required: true,
            validator: checkTransactorCardZheng,
            trigger: 'change'
          }
        ],
        transactorCardFan: [
          {
            required: true,
            message: '请上传身份证',
            trigger: 'change'
          }
        ]
      },
      searchBank: dictionaries.bankList,
      ProProp: {
        label: 'bank_Name',
        code: 'bankCode'
      },
      searchProvince: dictionaries.areaList,
      provinceProp: {
        label: 'areaName',
        code: 'areaCode'
      },
      provinceObj: {
        fId: 0
      },
      emptyFlag: 0,
      defaultBank: {
        bank_Name: '',
        bankCode: ''
      },
      defaultProvince: {
        areaName: '',
        areaCode: ''
      },
      defaultCity: {
        areaName: '',
        areaCode: ''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '长期',
            onClick(picker) {
              const leftValue = picker.$children[0].minDate; // 获取当前左侧选择日期,优先使用选择时的值。
              picker.$emit('pick', [leftValue, '长期']);
            }
          }
        ]
      }
    };
  },
  components: {
    step,
    UploadImgOne,
    dicSelect,
    step1Dt
  },
  computed: {
    cityObj() {
      return { fId: this.ruleForm.openBankProvinceCode };
    }
  },
  methods: {
    jumpContract() {
      location.href =
        '//cdn.yxvzb.com/WEB/PDF/web/%E6%AD%A6%E6%B1%89%E4%BC%97%E9%82%A6%E9%93%B6%E8%A1%8CE%E8%B4%A6%E9%80%9A%E7%B3%BB%E7%BB%9F%E5%BC%80%E6%88%B7%E4%B8%89%E6%96%B9%E5%8D%8F%E8%AE%AE-%E4%BC%81%E4%B8%9A%EF%BC%88V1.0%E7%89%88%E6%9C%AC%EF%BC%89.docx';
    },
    saveProId(val) {
      this.ruleForm.openBankName = val.bank_Name;
      this.ruleForm.openBankNode = val.bankCode;
      this.$refs.ruleForm.validateField('openBankName');
      // this.$refs['ruleForm'].$emit('el.form.change');
    },
    saveProvince(val) {
      this.ruleForm.openBankProvinceName = val.areaName;
      this.ruleForm.openBankProvinceCode = val.areaCode;
      this.ruleForm.openBankCityName = '';
      this.ruleForm.openBankCityCode = '';
      this.emptyFlag += 1;
      this.$refs.ruleForm.validateField('openBankCityCode');
      // this.$refs['ruleForm'].$emit('el.form.change');
    },
    saveCity(val) {
      this.ruleForm.openBankCityName = val.areaName;
      this.ruleForm.openBankCityCode = val.areaCode;
      // this.$refs['ruleForm'].$emit('el.form.change');
      this.$refs.ruleForm.validateField('openBankCityCode');
    },
    coverPicDone(v) {
      this.ruleForm.companyBusinessLicense = v;
      this.$refs.ruleForm.validateField('companyBusinessLicense');
    },
    coverPicDone2(v) {
      this.ruleForm.legalPersonCardZheng = v;
      this.$refs.ruleForm.validateField('legalPersonCardZheng');
    },
    coverPicDone3(v) {
      this.ruleForm.legalPersonCardFan = v;
      this.$refs.ruleForm.validateField('legalPersonCardZheng');
    },
    coverPicDone4(v) {
      this.ruleForm.transactorCardZheng = v;
      this.$refs.ruleForm.validateField('transactorCardZheng');
    },
    coverPicDone5(v) {
      this.ruleForm.transactorCardFan = v;
      this.$refs.ruleForm.validateField('transactorCardZheng');
    },
    submitForm(formName) {
      this.SET_BTLOADING(true);
      this.$refs[formName].validate(valid => {
        if (valid) {
          const bankAuthMap = {
            zbBank: this.authStatus.zbAuthStatus,
            fyBank: this.authStatus.fyAuthStatus
          };
          const id =
            bankAuthMap[this.selectBankName] === 0 ? null : this.ruleForm.id;
          const reqFormData = {
            ...this.ruleForm,
            payPassagewayCode: this.selectBankName,
            id
          };
          if (!id) {
            delete reqFormData.id;
          }
          dictionaries.addOpenAccount(reqFormData).then(async res => {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            // 线下开通后，进入结算中心。线上与全都展示按线上流程处理
            if (this.offlineProject === 2) {
              this.$emit('changeComp', { type: 0, currentCom: 'dashBoard' });
            } else {
              this.$emit('changeComp', { type: 1, currentCom: 'step2' });
            }
            this.SET_BTLOADING(false);
          });
        } else {
          this.SET_BTLOADING(false);
          return false;
        }
      });
    }
  },
  async created() {
    const {
      pdata: { offlineProject }
    } = await dictionaries.isOpenAccount();
    this.offlineProject = offlineProject;
    dictionaries
      .userOpenDetail({
        payPassagewayCode: this.selectBankName
      })
      .then(res => {
        if (res.data.data.userOpen) {
          this.ruleForm = res.data.data.userOpen;
          this.defaultBank = {
            bank_Name: this.ruleForm.openBankName,
            bankCode: this.ruleForm.openBankNode
          };
          this.defaultProvince = {
            areaName: this.ruleForm.openBankProvinceName,
            areaCode: Number(this.ruleForm.openBankProvinceCode)
          };
          this.defaultCity = {
            areaName: this.ruleForm.openBankCityName,
            areaCode: Number(this.ruleForm.openBankCityCode)
          };
        }
      });
  }
};
</script>
<style lang="scss">
.notes {
  margin-top: 30px;
  height: 46px;
  line-height: 46px;
  color: #bfbfbf;
  font-size: 14px;
  margin-bottom: 46px;
  text-align: left;
}
.flexItem {
  .el-form-item__content {
    display: flex;
    margin-left: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
.ruleForm {
  // width: 1500px;
  // margin: 0 auto;
}
.colorBlock {
  font-size: 20px;
  line-height: 25px;
  display: flex;
  color: #2e2e2f;
  font-weight: bold;
  padding: 5px 0;
}
.colorBlock::before {
  content: '';
  width: 10px;
  height: 25px;
  background: blue;
  margin-right: 5px;
  display: inline-block;
}
.flexBox {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 0px;
}
.elLabel {
  color: #333;
  font-size: 14px;
  font-weight: bold;
}
.redHint {
  color: #ef0707;
  font-style: normal;
  font-size: 12px;
  line-height: 17px;
  font-weight: normal;
  display: inline-block;
  text-align: left;
  width: 98px;
}
.leftLabel {
  width: 50%;
}
.rightLabel {
  width: 50%;
}
</style>
